module.exports = __webpack_public_path__ + "static/banner-two-shape7-8e770688bc9173fca5673af9b7721e47.png";